let coverFn = null
let revealFn = null

export function registerTransitionHandlers (handlers) {
  coverFn = handlers.cover
  revealFn = handlers.reveal
}

export function playCover () {
  return coverFn ? coverFn() : Promise.resolve()
}

export function playReveal () {
  return revealFn ? revealFn() : Promise.resolve()
}
